import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import CodeInputLite_vue_vue_type_script_setup_true_lang_default from "./CodeInputLite.vue.script.js";
/* empty css                            */
/* empty css                              */
//#region src/v2/components/code-input/CodeInputLite.vue
var CodeInputLite_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CodeInputLite_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-4dfd05a3"]]);
//#endregion
export { CodeInputLite_default as default };

//# sourceMappingURL=CodeInputLite.vue.js.map